import { render, staticRenderFns } from "./DeleteContact.vue?vue&type=template&id=9f2f8c66&scoped=true"
import script from "./DeleteContact.vue?vue&type=script&lang=js"
export * from "./DeleteContact.vue?vue&type=script&lang=js"
import style0 from "./DeleteContact.vue?vue&type=style&index=0&id=9f2f8c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2f8c66",
  null
  
)

export default component.exports